const styles = {
  portalBase: {
    ':hover': {
      transform: 'translate(-50%, -50%) scale(1.4)',
      opacity: 1,
    },
  },
  portal: (posX = 0, posY = 0, color = "#ffffff") => ({
    left: `${posX * 100}%`,
    top: `${posY * 100}%`,
    position: 'absolute',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    transition: 'all .2s linear',
    opacity: 0.6,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: '5px',
    boxSizing: 'border-box',
    color: '#fff',
    transform: 'translate(-50%, -50%)',
    backgroundColor: `${color}`,
    outline: 'none'
  }),
  selected: {
    opacity: 1,
    transform: 'translate(-50%, -50%) scale(1.4)',
    boxShadow: '0 0 10px black'
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerMinimap/MinimapPortal/MinimapPortal.styles.js